/**
 * Support: the support state at a glance (Oct 2026).
 *
 * Moved from the Support alert system's own dashboard (support-alert-system-385b1), stage 1 of
 * the plan agreed with the notify coordinator and the Support session on 21 Oct 2026. The state
 * comes from supportMonitor (functions/support/), through getSupportStatus: counts only.
 *
 * Who sees it (Lee, 21 Oct 2026): "Support can be seen by anyone if enabled in settings."
 * Administrators always; standard colleagues once an administrator switches it on in Settings →
 * tools. So its switch starts OFF (`switchedOnByDefault`, src/utils/toolAccess.js), the only
 * tool whose does.
 */
import { FaHeadset } from 'react-icons/fa';
import { BaseTool } from '../BaseTool';

export class SupportTool extends BaseTool {
  constructor() {
    super();
    this.id = 'support';
    this.name = 'Support';
    this.description = 'Who needs an answer now: open tickets, live chats and visitors waiting';
    this.icon = FaHeadset;
    // Fuchsia: an identity of its own. The page's content is colour-coded (red: a visitor is
    // waiting; green: chats under way; grey: clear), so the controls are neutral and this colour
    // marks only the tool (Critical Rule 1b: identity vs controls).
    this.color = '#a21caf';
    this.controlColor = 'neutral';
    this.path = '/dashboard/tools/support';
    // Reads support_relay (server-only) through getSupportStatus; owns nothing the page writes.
    this.collections = [];
    this.requiresAdmin = false;
    this.switchedOnByDefault = false;
  }

  async getSummaryData() {
    return { success: true, data: {}, lastUpdated: new Date() };
  }
}
